import { useFlags } from "launchdarkly-react-client-sdk";

import { useAppSelector } from "app/hooks";
import { LEADS_UI } from "constants/feature-flags";
import {
  selectCurrentPractice,
  selectCurrentUser
} from "features/auth/auth-slice";

export const LEADS_NOT_IN_PLAN_MESSAGE =
  "Suno Leads isn't part of your plan yet. Contact Suno to add it.";
export const LEADS_USER_NOT_PROVISIONED_MESSAGE =
  "Ask your practice admin to add you to Suno Leads.";

export type SunoLeadsAccess =
  | { enabled: true; reason: null; message: null }
  | {
      enabled: false;
      // The practice has no Leads (flag off, or no comms tenant) — an upsell;
      // or it has Leads and this user has no comms key — a provisioning gap.
      reason: "practice_without_leads" | "user_not_provisioned";
      message: string;
    };

// Whether this user can write to Suno Leads from outside /leads (ENG-2177
// "Save as lead"). The same two facts `LeadsProvider` gates the leads routes
// on — the `leadsUi` flag and `currentUser.comms_api_key` — plus the
// practice's comms tenant, which tells "not sold" from "not provisioned".
export default function useSunoLeadsAccess(): SunoLeadsAccess {
  const flags = useFlags();
  const practice = useAppSelector(selectCurrentPractice);
  const user = useAppSelector(selectCurrentUser);

  const practiceHasLeads =
    flags[LEADS_UI] === true && Boolean(practice?.suno_comms_id);
  if (!practiceHasLeads) {
    return {
      enabled: false,
      reason: "practice_without_leads",
      message: LEADS_NOT_IN_PLAN_MESSAGE
    };
  }
  if (!user?.comms_api_key) {
    return {
      enabled: false,
      reason: "user_not_provisioned",
      message: LEADS_USER_NOT_PROVISIONED_MESSAGE
    };
  }
  return { enabled: true, reason: null, message: null };
}
